// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import { createEffect } from "effector";
import {
  SettingsInfoResponseDTO,
  SettingsWriteRequestDTO
} from "../../api/backend-openapi";
import "whatwg-fetch";
import configuration from "../../utils/Config";
import {
  restCreationHandler,
  restGetUniqueHandler
} from "../../utils/rest/RestClient";

const baseUrl = configuration.backendBaseUrl;
const newsUrl = baseUrl + "/setting/";

export const requestGetSettings = createEffect({
  handler: restGetUniqueHandler<SettingsInfoResponseDTO>(newsUrl)
});
export const requestUpdateSettings = createEffect({
  handler: restCreationHandler<
    SettingsWriteRequestDTO,
    SettingsInfoResponseDTO
  >(newsUrl)
});
